import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import _ from 'lodash';
import React, { useCallback, useContext, useState } from "react";
import cx from 'classnames'
import { Flex } from '@jutro/layout'
import { Chevron, Icon } from '@jutro/components';
import { TranslatorContext } from "@jutro/locale";
import { ClausesComponentVM } from 'ent-components-platform-react';
import styles from '../TWIABuildingSummaryAccordions.module.scss';
import metadata from './TWIABuildingCoveragesAccordion.metadata.json5'
import messages from './TWIABuildingCoveragesAccordion.messages.js';
import { BldgLocContext } from "../../../context/BuildingsAndLocationContext.jsx";

function TWIABuildingCoveragesAccordion(props) {
    const { coverages, handleEditLinkClick, isConfirmationStep, isAdditionalStep, isBuildingSummary, wizardStep, fromBuilding } = props;
    const translator = useContext(TranslatorContext)
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const [selectedLocation, setSelectedLocation] = chosenLocation;
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    const [buildingVM, setBuildingVM] = useState(selectedLocation.buildings?.children[selectedBuildingIndex]);
    // DE15994
    const coveragesToShow = buildingVM?.coverages.value.filter(blgCov =>
         blgCov.buildingCovCategory_TWIA === "Property Coverage" && blgCov.selected)
    const blanketCov = _.find(buildingVM?.blanket_TWIA?.value?.coverages, (cov) => 
        cov.publicID === 'CPBlanketCov');
    const buildingCov = _.find(coveragesToShow, (cov) => cov.publicID === 'CPBldgCov');

    // US26260
    // eslint-disable-next-line camelcase
    const getCoverageSummarySubHeading_TWIA = useCallback(() => {
        // DE15999
        if ( blanketCov) {
            return blanketCov.name
        }

        if(coveragesToShow.length > 1) {
            return `${coveragesToShow[0]?.name  } ${ translator(messages.concatWordforCoverages) } ${  coveragesToShow[1]?.name}`
        }

        if(coveragesToShow.length === 1) {
            return `${coveragesToShow[0]?.name}`
        }

        return buildingCov?.name
    }, [blanketCov, buildingCov, coveragesToShow, translator])

    const coveragesHeader = useCallback((isOpen) => (
        <Flex justifyContent="between" className={styles.fullWidth}>
            <Icon
                icon="gw-coverages"
                id="locCheck"
                size="medium"
            />
            <div className={cx(styles.heading, styles.headingBold, styles.flexOneThird)}>{translator(messages.coveragesHeading)}</div>
            <div className={cx(styles.heading, styles.flexOneThird)}>{getCoverageSummarySubHeading_TWIA()}</div>
            <Chevron className={styles.chevronMargin} isOpen={isOpen} />
        </Flex>
    ), [])



    const editCoverages = useCallback(() => {
        if (wizardStep === -1 || isConfirmationStep) {
            handleEditLinkClick(3, false, undefined, undefined, buildingVM)
        } else {
            handleEditLinkClick(3,  undefined, undefined, undefined, buildingVM)
        }
    }, [])

    const overrideProps = {

        buildingCoveragesComponent: {
            value: buildingVM.coverages.value,
            path: 'coverages',
            splitByClauseCategory: true,
            isEditable: false,
            showAmount:false,
            showCoverageNameAmount : false,
            isResidentialSummary: true
        },
        blanketCoveragesComponent: {  // Edit Coverages - Show Blanket Coverage
            visible:  !_.isUndefined(buildingVM.value.blanket_TWIA),
            value: buildingVM?.blanket_TWIA.coverages?.value,
            path: 'coverages',
            splitByClauseCategory: true,
            isEditable: false,
            showAmount:false,
            showCoverageNameAmount : false,
            isResidentialSummary: true
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            coveragesHeader,
            editCoverages
        },
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
        },
        resolveClassNameMap: styles

    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={buildingVM}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    )
}

export default TWIABuildingCoveragesAccordion
